import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export interface BekraftaProps {
  antalFastigheter: number;
  forteckningType: string;
  onCancel: () => void;
  onConfirm: () => void;
  show: boolean;
}

export const Confirm: React.FC<BekraftaProps> = ({
  antalFastigheter,
  forteckningType,
  onCancel,
  onConfirm,
  show,
}) => {
  if (!show) {
    return null;
  }

  const suffixFastigheter =
    antalFastigheter > 1 ? ' fastigheter' : ' fastighet';

  return (
    <Dialog open={show}>
      <DialogTitle>Bekräfta</DialogTitle>
      <DialogContent>
        {forteckningType === 'METAGRA' ? (
          <DialogContentText>
            Förteckningen omfattar {antalFastigheter} {suffixFastigheter} samt
            förmånsfastigheter som har rättigheter på
            {antalFastigheter > 1
              ? ' de inlästa fastigheterna'
              : ' den inlästa fastigheten'}
            .<br />
            <br /> Ni blir debiterade enligt avtal för antalet inlästa
            fastigheter som ger en träff i fastighetsregistret samt en
            startavgift. <br />
            <br />
            Utöver detta debiteras ni även för lagfartsinformationen gällande de
            förmånsfastigheter som innehar rättighetsförmåner på era inlästa
            fastigheter. <br />
            <br />
            Mer information om förteckningar och priser hittar du på våra
            hjälpsidor.
          </DialogContentText>
        ) : (
          <DialogContentText>
            Förteckningen omfattar {antalFastigheter} {suffixFastigheter}
            .<br />
            Ni blir debiterad enligt avtal för antalet unika fastigheter som ger
            en träff i fastighetsregistret samt en startavgift.
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Avbryt</Button>
        <Button variant="contained" onClick={() => onConfirm()} autoFocus>
          Bekräfta
        </Button>
      </DialogActions>
    </Dialog>
  );
};
